module.exports = __webpack_public_path__ + "static/img/page16.ec15f47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page16.jpg
// module id = T5hC
// module chunks = 0